function AutoFilterFormValueConditionLayout ( props ) {

    const { children } = props;

    return (
        <div>
        { children }
        </div>
    );

}

export default AutoFilterFormValueConditionLayout;

